import ReactGA from 'react-ga';

function GoogleAnalytics(uid) {
  ReactGA.initialize({
    gaTrackingID: uid
  });
  ReactGA.pageview(window.location.pathname + window.location.search);
}

export default GoogleAnalytics;